import React from 'react'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'

function PublicKnowledgeBase() {
  return (
    <div className="space-y-6">
      <div className="text-center">
        <h1 className="text-4xl font-bold text-foreground">Mission Solar Wissensdatenbank</h1>
        <p className="text-xl text-muted-foreground mt-2">
          Finden Sie Antworten auf häufig gestellte Fragen
        </p>
      </div>

      <Card>
        <CardHeader>
          <CardTitle>Öffentliche Wissensdatenbank (Coming Soon)</CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-muted-foreground">
            Die öffentliche Ansicht der Wissensdatenbank wird in der nächsten Phase implementiert.
          </p>
        </CardContent>
      </Card>
    </div>
  )
}

export { PublicKnowledgeBase }